<template>
  <div></div>
</template>

<script>
export default {
  methods: {
    open(data = {}) {
      const {
        title = "title",
        html = false,
        icon = "success",
        reverseButtons = true,
        showCancelButton = false,
        cancelButtonText = "ปิด",
        cancelButtonColor = "#00A99D",
        showConfirmButton = false,
        confirmButtonText = "ปิด",
        confirmButtonColor = "#00A99D",
        allowOutsideClick = true,
        returnEmit = "",
        timer = false,
      } = data
      this.$swal
        .fire({
          position: "center",
          icon: icon,
          title: title,
          html: html,
          reverseButtons: reverseButtons,
          showCancelButton: showCancelButton,
          cancelButtonText: cancelButtonText,
          cancelButtonColor: cancelButtonColor,
          showConfirmButton: showConfirmButton,
          confirmButtonText: confirmButtonText,
          confirmButtonColor: confirmButtonColor,
          allowOutsideClick: allowOutsideClick,
          timer: timer,
        })
        .then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.$emit("submit", returnEmit )
          } else {
            this.$emit("unsubmit", returnEmit )
          }
        })
    },
  },
}
</script>

<style>
.swal2-styled.swal2-cancel {
  border: 1px solid #F5222D !important;
  width: 100px;
}

.swal2-styled.swal2-confirm {
  width: 100px;
}
</style>